import { status } from "skin/event/status";

const expireFields = ["expireScalar", "expireUnitValue"];

const expireFieldSetFx = (data) => {
	data.setValue(
		"expire",
		Number.parseInt(data.s.values.fld.expireScalar) *
			Number.parseInt(data.s.values.fld.expireUnitValue),
	);
	return status.action;
};

export default function rewList(obj, form, story, data, d, action) {
	if (obj.action === "setEnd" && expireFields.includes(obj.name))
		return expireFieldSetFx(data);
	return status.action;
}
